import IntroductionWithImage from "../../../components/IntroductionWithImage";
import MainImageCarousel from "../../../components/MainImageCarousel";
import StickyNavAndFooter from "../../layout/StickyNavAndFooter";
import { hataYogaBeginnerCards, hataYogaAdvancedCards, yogaMainBlog, hathaYogaPageIntroduction } from "../../../data/data";
import { Box, Button, Tooltip, useDisclosure } from "@chakra-ui/react";
import hathaYogaSymbolImg from '../../../resources/images/hathasymbol.jpeg'
import { headingTertiaryFont, primaryColor, secondaryColorTwo } from "../../../config";
import { CarouselCardDetails_t } from "../../../components/Carousels/CarouselCard";
import CardCarousalContainer from "../../../components/CardCarousalContainer";
import ModalPost from "../../../components/ModalPost";
import { useState } from "react";
import yogaSpace from '../../../resources/images/sds_space.jpeg'
import trikonasana from '../../../resources/images/trikonasana.png'
import bhuthaShuddhi from '../../../resources/images/bhutashuddhi.jpg'
import angamardhanaStanding from '../../../resources/images/angamardhana_standing.png'
import angamardhanaSitting from '../../../resources/images/angamardhana_sitting.jpg'
import suryaKriya from '../../../resources/images/suryakriya.jpg'

export default function HathaYoga() {
    const { isOpen, onToggle } = useDisclosure()
    const yogaMainBlogForYogaPage: CarouselCardDetails_t = yogaMainBlog
    delete yogaMainBlogForYogaPage.previous;
    delete yogaMainBlogForYogaPage.next;
    function onClose() {
        onToggle()
    }

    const [openPost, setOpenPost] = useState<CarouselCardDetails_t | undefined>(undefined);

    function handleClick(id: string) {
        onToggle()
        setOpenPost([...hataYogaBeginnerCards, ...hataYogaAdvancedCards, yogaMainBlogForYogaPage].filter(card => card.groupId + "_" + card.id == id)[0])
    }

    return (
        <StickyNavAndFooter>
            <MainImageCarousel imageList={[
                {
                    img: yogaSpace,
                    size: { base: "contain", md: "95rem 45rem" },
                    position: { base: "center", md: "2.5rem -1.5rem" },
                    navigatableLink: "",
                    alt: ""
                },
                {
                    img: trikonasana,
                    size: "contain",
                    position: "center",
                    navigatableLink: "",
                    alt: ""
                },
                {
                    img: bhuthaShuddhi,
                    size: "contain",
                    position: "center",
                    navigatableLink: "",
                    alt: ""
                },
                {
                    img: angamardhanaStanding,
                    size: "contain",
                    position: "center",
                    navigatableLink: "",
                    alt: ""
                },
                {
                    img: angamardhanaSitting,
                    size: "contain",
                    position: "center",
                    navigatableLink: "",
                    alt: ""
                },
                {
                    img: suryaKriya,
                    size: "contain",
                    position: "center",
                    navigatableLink: "",
                    alt: ""
                }
            ]} />
            <IntroductionWithImage img={hathaYogaSymbolImg}>
                {hathaYogaPageIntroduction}
                <br />
                <Box textAlign={"right"}>
                    <Button bg={primaryColor} color={"white"} onClick={() => handleClick(yogaMainBlogForYogaPage.groupId + "_" + yogaMainBlogForYogaPage.id)}
                        _hover={{
                            backgroundColor: secondaryColorTwo,
                        }}>Read</Button>
                </Box>
            </IntroductionWithImage>
            <br />
            <Box id={"hatha-yoga-beginner"}>
                <CardCarousalContainer cards={hataYogaBeginnerCards}
                    containerTitle={"Classical Hatha Yoga"}
                    subTitle="Beginner's Guide for Physical and Mental Health"

                />
            </Box>
            <br />
            <br />
            <Box id={"hatha-yoga-advanced"}>
                <CardCarousalContainer cards={hataYogaAdvancedCards}

                    subTitle="More than Physical and Mental Dimensions" />
            </Box>
            <Box textAlign={"center"} as="a" href={"#contactUs"}>
                <Tooltip label="" aria-label="Contact Us for more information">
                    <Box m='auto' fontSize={headingTertiaryFont}
                        color={primaryColor}>
                        Contact Us for more information
                    </Box>
                </Tooltip>
            </Box>

            {isOpen && openPost && <ModalPost card={openPost}
                isOpen={isOpen}
                onClose={onClose}
                hideNavigation={true} />}
        </StickyNavAndFooter>
    )
}